import React,{useState,useEffect} from 'react'
import { MenuItem, Stack } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { getRequestThunk, approveLimitThunk, disapproveLimitThunk, getRequestWithoutLoadingThunk } from '../../ReduxStore/Request'
import { useNavigate } from 'react-router-dom'

import Layout from '../../ReuseComponent/Layout/Layout'
import BasicMenu from '../ExistingAccount/menu/menu'
import Loader from '../Loader/Loader'
import Details from './Details'


const Request = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const store = useSelector(state => state.request)
    const auth = JSON.parse(window.localStorage.getItem("auth"));


    const [page, setPage] = useState(1)
    const [data, setData] = useState(null)

    useEffect(()=> {
        dispatch(getRequestThunk())
        .catch(error => {
            if (error.response.status === 401) navigate('/login')

        })
    },[])

    const [openMenu, setOpenMenu] = useState(null);
    const handleOpenMenu = (event) => {
        setOpenMenu(event.currentTarget);
      };

    const [openLoaderMenu, setOpenLoaderMenu] = useState(null);
    const handleOpenLoaderMenu = (event) => {
        setOpenLoaderMenu(event.currentTarget.parentElement.parentElement);
      }; 

    const handleApprove = (e) => {
        setOpenMenu(false)
        handleOpenLoaderMenu(e)
        
        dispatch(approveLimitThunk({
            adminId: auth.id,
            limitId: data.id,
            userId: data.zikora_user_id
        }))
        .then(val=> {
            dispatch(getRequestWithoutLoadingThunk())
            .then(val => setOpenLoaderMenu(false))
        })
        .catch(error => {
            if (error.response.status === 401) navigate('/login')

        })

    }  

    const handleDisapprove = (e) => {
        setOpenMenu(false)
        handleOpenLoaderMenu(e)
        dispatch(disapproveLimitThunk({
            adminId: auth.id,
            limitId: data.id,
            userId: data.zikora_user_id
        }))
        .then(val=> {
            dispatch(getRequestWithoutLoadingThunk())
            .then(val => setOpenLoaderMenu(false))
        })
        .catch(error => {
            if (error.response.status === 401) navigate('/login')

        })

    } 
   
  return (
    <div>
        <BasicMenu openMenu={openMenu} setOpenMenu={setOpenMenu}>
            <MenuItem sx={{color: '#1AC847'}} onClick={handleApprove}>Approve</MenuItem>
            <MenuItem sx={{color: '#FF4040'}} onClick={handleDisapprove}>Disapproved</MenuItem>
        </BasicMenu>

        <BasicMenu openMenu={openLoaderMenu} setOpenMenu={setOpenLoaderMenu}>
            <Loader />
        </BasicMenu>

        <Layout label={'Request'}>

            {page === 1 && <div style={{marginTop: '2rem', width: '80vw', height: '80vh', overflow: 'auto'}}>

                {!store.loading && <table style={{
                    border: '1px solid #E4E4E4',
                    width: '100%',
                    borderRadius: '7px',
                }}>
                    <thead style={{
                         position: 'sticky',
                         top: 0,
                         backgroundColor: 'white'
                    }}>
                        {[
                            "Account Name",
                            "Amount",
                            "Date",
                            "Details",
                            "Action"
                        ]
                        .map((val, index) => <td 
                            style={{
                                borderBottom: '1px dashed #E4E4E4',
                                padding: '20px 0',
                                fontSize: '12px',
                                color: '#404040',
                                fontWeight: '600',
                                paddingLeft: index === 0 ? '10px': '0',
                                
                            }}
                        >{val.toLocaleUpperCase()}</td>)}
                    </thead>
                    <tbody>
                        {store.requests?.map(val=>{
                           const timestamp = Date.parse(val.created_at); // convert the date string to a timestamp
                           const date = new Date(timestamp); // create 
                            return (<tr style={{height:'84px', }}>

                            <td style={{padding: '0 15px',  fontSize: '14px', fontWeight: '600', color:'#252424',}}>
                                <Stack direction={'row'} alignItems={'center'} spacing={2}>

                                    <img src={val?.image} alt="" style={{height: '50px', width: '50px', borderRadius: '25px'}}/>
                                    <p>{val?.account_name.toString().toLocaleUpperCase()}</p>
                                </Stack>

                            </td>

                            <td style={{fontSize: '12px', fontWeight: '500', color: '#404040'}}>{val?.amount}</td>
                            <td style={{fontSize: '12px', color: '#8D8D8D'}}>{date.toLocaleString()}</td>
                            <td style={{fontSize: '12px', fontWeight: '600', color: '#66A681', cursor:'pointer'}} onClick={()=>{setData(val); setPage(2)}}>{'View Details'.toLocaleUpperCase()}</td>
                            
                            <td style={{cursor: 'pointer',}} onClick={(e)=>{handleOpenMenu(e); setData(val)}}>
                                
                                <span className={val?.status === 'pending' ? 'pending' : val?.status === 'approved' ? 'approve' : 'disapprove'} 
                                style={{ color: val?.status === 'approved' ? "green" : val?.status === 'disapproved' ? 'red' : 'black'}}><div className='bullet'>
                                </div>{val?.status}</span> 
                            </td>
                            
                        </tr>)
                        })
                        }
                    </tbody>
                </table>}
                {store.loading && <Loader />}
            </div>}

            {page === 2 && <div style={{marginTop: '2rem', width: '80vw'}}>
                <Details data={data} setPage={setPage}/>
            </div>}



        </Layout>
    </div>
  )
}

export default Request



